import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["color", "bg"],
    _excluded2 = ["src", "width", "height", "size"],
    _excluded3 = ["reverse"];
/** @jsx jsx */

import { jsx } from 'theme-ui';
import React from 'react';
import useSteps from './use-steps';
import { jsx as ___EmotionJSX } from "@emotion/core";

var createComponent = function createComponent(key) {
  var Component = function Component() {
    return false;
  };

  Component.__mdxDeck = true;
  Component["__mdxDeck_" + key] = true;
  return Component;
};

export var Notes = createComponent('notes');
export var Head = createComponent('head');
export var Header = createComponent('header');
export var Footer = createComponent('footer');
export var Color = function Color(_ref) {
  var color = _ref.color,
      bg = _ref.bg,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return jsx("div", _extends({}, props, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      color: color,
      bg: bg,
      a: {
        color: 'inherit'
      }
    }
  }));
};
export var Invert = function Invert(props) {
  return jsx(Color, _extends({}, props, {
    color: "background",
    bg: "text"
  }));
};
export var StepList = function StepList(props) {
  var list = React.Children.toArray(props.children).find(function (child) {
    return /^(ul|ol)$/.test(child.props.originalType);
  }); // ensure this works

  var items = React.Children.toArray(list && list.props.children);
  var step = useSteps(items.length);
  var children = items.map(function (item, i) {
    return /*#__PURE__*/React.cloneElement(item, {
      style: {
        visibility: i < step ? 'visible' : 'hidden'
      }
    });
  });
  return /*#__PURE__*/React.cloneElement(list, {
    children: children
  });
};
export var Appear = function Appear(props) {
  var children = React.Children.toArray(props.children);
  var step = useSteps(children.length);
  var styled = children.map(function (child, i) {
    return /*#__PURE__*/React.cloneElement(child, {
      style: {
        visibility: i < step ? 'visible' : 'hidden'
      }
    });
  });
  return jsx(React.Fragment, null, styled);
};
export var Steps = function Steps(props) {
  var list = React.Children.toArray(props.children).find(function (child) {
    return /^(ul|ol)$/.test(child.props.originalType);
  });
  if (!list) return jsx(Appear, props);
  return jsx(StepList, props);
};
export var Image = function Image(_ref2) {
  var src = _ref2.src,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100%' : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '100%' : _ref2$height,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'cover' : _ref2$size,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return jsx("div", _extends({}, props, {
    sx: {
      width: width,
      height: height,
      backgroundSize: size,
      backgroundImage: "url(" + src + ")",
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }
  }));
};
export var Horizontal = function Horizontal(_ref3) {
  var props = Object.assign({}, _ref3);
  var children = React.Children.toArray(props.children);
  return jsx("div", _extends({}, props, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      textAlign: 'center'
    }
  }), children.map(function (child, i) {
    return jsx("div", {
      key: child.key,
      sx: {
        width: 100 / children.length + '%',
        img: {
          height: 'auto'
        }
      }
    }, child);
  }));
};

var Half = function Half(props) {
  return jsx("div", _extends({}, props, {
    sx: {
      width: '50%',
      img: {
        height: 'auto'
      }
    }
  }));
};

export var Split = function Split(_ref4) {
  var reverse = _ref4.reverse,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded3);

  var _React$Children$toArr = React.Children.toArray(props.children),
      first = _React$Children$toArr[0],
      rest = _React$Children$toArr.slice(1);

  var children = reverse ? [jsx(Half, {
    key: "rest"
  }, rest), jsx(Half, {
    key: "first"
  }, first)] : [jsx(Half, {
    key: "first"
  }, first), jsx(Half, {
    key: "rest"
  }, rest)];
  return jsx("div", _extends({}, props, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      textAlign: 'center'
    }
  }), children);
};
export var SplitRight = function SplitRight(props) {
  return jsx(Split, _extends({}, props, {
    reverse: true
  }));
};
export var FullScreenCode = function FullScreenCode(_ref5) {
  var props = Object.assign({}, _ref5);
  return jsx("div", _extends({}, props, {
    sx: {
      width: '100%',
      height: '100%',
      pre: {
        // hack for prism styles
        margin: '0 !important',
        width: '100%',
        height: '100%',
        overflow: 'auto'
      }
    }
  }));
};